module.exports = __webpack_public_path__ + "img/desktop_title.1bcb1561.svg";